const refs = 'about'
export default [
    { 
        path: '/'+refs, 
        name: refs, 
        component: () => import('@/views/'+refs+'/List.vue')
    },
    { 
        path: '/directors', 
        name: 'directors', 
        component: () => import('@/views/'+refs+'/Directors.vue')
    },
    { 
        path: '/gallery', 
        name: 'gallery', 
        component: () => import('@/views/'+refs+'/Gallery.vue')
    },
    { 
        path: '/videos', 
        name: 'videos', 
        component: () => import('@/views/'+refs+'/Videos.vue')
    },

]
